<template>
	<div>
		<div>
			<span class="xbed-sub-title">管家物资出入库表</span>
		</div>
		<div class="xbed-breadcrumb">
			<Breadcrumb>
				<BreadcrumbItem>麗家会</BreadcrumbItem>
				<BreadcrumbItem>管家物资出入库表</BreadcrumbItem>
			</Breadcrumb>
		</div>
		<br>
		<Form @submit.native.prevent="preventSubmit" inline>
			<FormItem prop="month" label="物资变化时间：" :label-width="110">
				<DatePicker type="month" v-model="checkQueryParams.month" placeholder="选择日期" style="width: 150px" :clearable="false"></DatePicker>
			</FormItem>
			<FormItem prop="userName" label="管家姓名：" :label-width="84">
				<Input type="text" v-model="checkQueryParams.userName" style="width:150px"></Input>
			</FormItem>
			<FormItem prop="cleanerAccount" label="管家号码：" :label-width="84">
				<Input type="text" v-model="checkQueryParams.cleanerAccount" style="width:150px"></Input>
			</FormItem>
			<FormItem prop="cleanerAccount" label="物品名称：" :label-width="84">
				<Input type="text" v-model="checkQueryParams.goodsName" style="width:150px"></Input>
			</FormItem>
			<FormItem prop="cleanerAccount" label="物料编号：" :label-width="84">
				<Input type="text" v-model="checkQueryParams.stockNumber" style="width:150px"></Input>
			</FormItem>
			<br>
			<FormItem prop="cleanerAccount" label="关联城市：" :label-width="84">
				<Input type="text" v-model="checkQueryParams.associatedCityName" style="width:180px"></Input>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="queryAccountListWithKeyword">查询</Button>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="exportTable" :loading="exportBtn">导出表格</Button>
			</FormItem>
		</Form>
		<Content>
			<Table :columns="columns" :data="accountList"></Table>
			<div style="margin: 10px;overflow: hidden">
				<Page show-sizer placement="top" :current="checkQueryParams.page" :total="listTotal" :page-size="checkQueryParams.pageSize" @on-change="changePage" @on-page-size-change="changePageSize"></Page>
			</div>
		</Content>
	</div>
</template>
<script>
import Moment from "moment";
import Utils from "@/utils";
import API from "@/api";
import Config from "@/config";
import expandRow from "@/components/table-housekeepingMaterials";

export default {
	created() {
		this.token = Utils.findFromLocalStorage( "vue-token" );
		this.env = Utils.findFromLocalStorage( "env", "dev" );
	},
	components: {expandRow},
	data() {
		return {
			exportBtn: false,
			accountList: [],
			//   分页
			listTotal: 0,
			// 查询数据
			checkQueryParams: {
				month: Moment()
					.add( "month" )
					.format( "YYYY-MM" ),
				userName: "",
				cleanerAccount: "",
				goodsName: "",
				stockNumber: "",
				page: 1,
				pageSize: 10,
				associatedCityName: ''
			},
			queryParams: {
				month: Moment()
					.add( "month" )
					.format( "YYYY-MM" ),
				userName: "",
				cleanerAccount: "",
				goodsName: "",
				stockNumber: "",
				page: 1,
				pageSize: 10,
				associatedCityName: ''
			},
			columns: [
				{
					title: "查看",
					align: "center",
					type: 'expand',
					width: 70,
					render: ( h, params ) => {
						return h( expandRow, {
							props: {
								row: params.row.List
							}
						})
					}
				},
				{
					title: "操作",
					align: "center",
					key: "monthAfterAmount",
					width: 80,
					render: ( h, params ) => {
						return h( "div", [
							h(
								"Button",
								{
									props: {
										size: "small",
										type: "primary"
									},
									on: {
										click: () => {
											if ( !Utils.hasPermission( 'oms_xbclean_MaterialUpdateDetailsList_list' ) ) {
												this.$Notice.error( {
													title: "无权限操作"
												} );
												return
											}
											if ( this.$router ) {
												window.open( `#/app/cleaner/MaterialUpdateDetailsList?cleanerId=${ params.row.cleanerId }` )      //跳转至管家库存明细表 
											} else {
												window.open( `#/Cleaner/Cleaner/MaterialUpdateDetailsList?cleanerId=${ params.row.cleanerId }` );
											}
										}
									}
								},
								"查看详情"
							)
						] );
					}
				},
				{
					title: "管家id",
					align: "center",
					key: "cleanerId",
					width: 80
				},
				{
					title: "管家姓名",
					align: "center",
					key: "userName",
					width: 100
				},
				{
					title: "管家号码",
					align: "center",
					key: "cleanerAccount",
					width: 150
				},
				{
					title: "管家城市",
					align: "center",
					key: "associatedCityName",
					width: 120
				},
				{
					title: "物品id",
					align: "center",
					width: 80
				},
				{
					title: "物品名称",
					align: "center",
					width: 130
				},
				{
					title: "物料编号",
					align: "center",
					width: 130
				},
				{
					title: "一级类别",
					align: "center",
					width: 100,
				},
				{
					title: "规格",
					align: "center",
					width: 100
				},
				// {
				//   title: "期初单价（元）",
				//   align: "center",
				//   width: 100,
				// },
				{
					title: "期初数量",
					align: "center",
					width: 100
				},
				// {
				//   title: "期初金额（元）",
				//   align: "center",
				//   width: 100,
				// },
				// {
				//   title: "入库单价（元）",
				//   align: "center",
				//   width: 100,
				// },
				{
					title: "入库数量",
					align: "center",
					width: 100
				},
				// {
				//   title: "入库金额（元）",
				//   align: "center",
				//   width: 100,
				// },
				// {
				//   title: "出库单价（元）",
				//   align: "center",
				//   width: 100,
				// },
				{
					title: "出库数量",
					align: "center",
					width: 100
				},
				// {
				//   title: "出库金额（元）",
				//   align: "center",
				//   width: 100,
				// },
				// {
				//   title: "期末单价（元）",
				//   align: "center",
				//   width: 100,
				// },
				{
					title: "期末数量",
					align: "center",
					width: 100
				},
				// {
				//   title: "期末金额（元）",
				//   align: "center",
				//   width: 100
				// },
			]
		};
	},
	mounted() {
		this.queryGoodsList();
		this.$Notice.config( {
			top: 200
		} )
	},
	methods: {
		// 获取所有管家
		async queryGoodsList() {
			this.queryParams.month = this.checkQueryParams.month
				? Moment( this.checkQueryParams.month ).format( "YYYY-MM" )
				: "";
			let resp = ( await API.omsAPI[this.env].cleaner.MmMonthlyStewardGoodsInventory( this.queryParams, this.token ) ).data;
			if ( resp.retCode ) {
				this.$Notice.error( {
					title: "获取列表失败",
					desc: resp.msg
				} );
				return;
			}
			this.accountList = resp.content || [];
			this.listTotal = resp.totalCount;
		},
		//   查询
		queryAccountListWithKeyword() {
			this.queryParams = Object.assign( {}, this.checkQueryParams );
			this.queryGoodsList();
		},
		// 分页
		changePage( pageIndex ) {
			this.page = pageIndex;
			this.queryGoodsList();
		},
		changePageSize( pageSize ) {
			this.queryParams.page = 1;
			this.queryParams.pageSize = pageSize;
			this.queryGoodsList();
		},
		// 导出表格
		exportTable() {
			if ( !Utils.hasPermission( 'excel_MmStewardGoodsInventoryParticular' ) ) {
				this.$Notice.error( {
					title: "无权限操作"
				} );
				return
			}
			if ( this.accountList.length === 0 ) {
				this.$Notice.error( {
					title: "没数据可导"
				} );
				return;
			}
			let params = {
				cleanerAccount: this.queryParams.cleanerAccount,
				userName: this.queryParams.userName,
				month: this.queryParams.month,
				goodsName: this.queryParams.goodsName,
				stockNumber: this.queryParams.stockNumber,
				associatedCityName: this.queryParams.associatedCityName,
				page: 1,
				pageSize: 99999,
			};
			const initParam = params => {
				let paramStr = "";
				Object.keys( params ).forEach( item => {
					if ( params[item] !== "" ) {
						paramStr += item + "=" + params[item] + "&";
					}
				} );
				return paramStr.substring( 0, paramStr.lastIndexOf( "&" ) );
			};
			let paramStr = initParam( params );
			let url = `${
				Config[this.env].analysisUrl
				}excel/MmMonthlyStewardGoodsInventory?${ paramStr }`;
			// window.open(url, "_blank");
			Utils.exportExcelWeighting( url, this.token, this.$Notice.error, this, "exportBtn" )
		}
	},
	preventSubmit() {
		return false;
	}
};
</script>



// WEBPACK FOOTER //
// src/pages/cleaner/housekeepingMaterials-list.vue